import {
  ISkipOverallStatistics,
  IDriverSkipStatsResponse,
  ISkipHistoryResponse,
  ISkipReasonsBreakdownResponse,
} from "../../models/skip-analytics/response";
import {
  ISkipAnalyticsQuery,
  ISkipHistoryQuery,
} from "../../models/skip-analytics/query";
import { HttpClient, RequestParams } from "../../utils/api/http-client";

class SkipAnalyticsService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  // Get overall skip statistics
  getOverallStatistics = (
    query?: { from_date?: string; to_date?: string },
    params?: RequestParams
  ) =>
    this.http.request<ISkipOverallStatistics>({
      path: `/analytics/trip-skips/overall`,
      method: "GET",
      query: query,
      ...params,
    });

  // Get all drivers skip statistics
  getDriversSkipStats = (query?: ISkipAnalyticsQuery, params?: RequestParams) =>
    this.http.request<IDriverSkipStatsResponse>({
      path: `/analytics/trip-skips/drivers`,
      method: "GET",
      query: query,
      ...params,
    });

  // Get driver skip history
  getDriverSkipHistory = (
    driverId: number,
    query?: ISkipHistoryQuery,
    params?: RequestParams
  ) =>
    this.http.request<ISkipHistoryResponse>({
      path: `/analytics/trip-skips/drivers/${driverId}/history`,
      method: "GET",
      query: query,
      ...params,
    });

  // Get skip reasons breakdown for charts
  getReasonsBreakdown = (
    query?: { from_date?: string; to_date?: string; driver_id?: number },
    params?: RequestParams
  ) =>
    this.http.request<ISkipReasonsBreakdownResponse>({
      path: `/analytics/trip-skips/reasons-breakdown`,
      method: "GET",
      query: query,
      ...params,
    });
}

export default SkipAnalyticsService;
